import React, { useEffect } from 'react';
import styles from './MobileSidebar.module.css';

export default function MobileSidebar({ isOpen, onClose }) {
  // 控制 body 滚动
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }

    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, [isOpen]);

  // 页面内跳转函数
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      onClose(); // 跳转后关闭侧边栏
    }
  };

  return (
    <>
      {/* 遮罩层 */}
      {isOpen && (
        <div
          className={styles.overlay}
          onClick={onClose}
        />
      )}

      {/* 侧边栏 */}
      <div className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
        <div className={styles.header}>
          <img
            className={styles.logo}
            src="/images/logos/ntx-logo-full.png"
            alt="Logo"
          />
          <button className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        <nav className={styles.nav}>
          <div className={styles.navItem} onClick={() => scrollToId('section-hero')}>
            <span>立即开始</span>
            <svg className={styles.arrow} width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <div className={styles.navItem} onClick={() => scrollToId('section-about')}>
            <span>关于NTX</span>
            <svg className={styles.arrow} width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <div className={styles.navItem} onClick={() => scrollToId('section-partners')}>
            <span>合作伙伴</span>
            <svg className={styles.arrow} width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <div className={styles.navItem} onClick={() => scrollToId('section-community')}>
            <span>相关服务</span>
            <svg className={styles.arrow} width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </nav>
      </div>
    </>
  );
}
